import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { patchAnimation } from '@/services/user';
import { useTheme } from '@/providers/theme-provider';
import { useAuthenticationDispatch } from '@/hooks/use-authentication';
import { errorHandler } from '@/lib/utils';
/**
 * Apply an ambient-animation choice locally for instant feedback, then
 * persist to the backend. Mirrors `useThemeMutation` /
 * `usePaletteMutation` — same apply-then-mutate pattern, same
 * UPDATE_USER dispatch shape, so subscribers stay in lockstep.
 */
export function useAnimationMutation() {
    const { setAnimation } = useTheme();
    const dispatch = useAuthenticationDispatch();
    const { mutate, isPending } = useMutation({
        mutationFn: patchAnimation,
        onSuccess: (data) => {
            toast.success(data.message);
            dispatch({ type: 'UPDATE_USER', user: data.user });
        },
        onError: errorHandler,
    });
    const updateAnimation = (next) => {
        setAnimation(next);
        mutate({ animation: next });
    };
    return { updateAnimation, isPending };
}
